import React, { useState } from 'react';

// DEPENDENCIES
import { useParams } from 'react-router';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// TOOLS
import ExcelButtons from 'routers/interface/tools/ExcelButtons';

// LOCAL TOOLS
import SearchTool from '../../tools/SearchTool';
import useRecordView from 'helpers/getRecordView';

// COMPONENTS
const ActivityTools = ({ name }) => {
  const [searchFieldName, setSearchFieldName] = useState();

  // REACT ROUTER
  const { recordID } = useParams();

  // CONTEXT
  const { view } = useRecordView() || {};

  // RENDER
  return [
    <SearchTool
      key="searchTool"
      name={name}
      label="recent activity"
      onChange={setSearchFieldName}
    />,
    view === 'inventory' && 
      <ExcelButtons
        key="inventoryActivity"
        fileName="inventory_activity"
        label="recent activity"
        args={{
          endpoint: ENDPOINTS.inventory.activityLog(recordID),
          params: {
            fieldName: searchFieldName,
            downloadExcel: true
          }
        }}
      />,
    view !== 'inventory' &&
      <ExcelButtons
        key="salesActivity"
        fileName="sales_activity"
        label="recent activity"
        args={{
          endpoint: ENDPOINTS.sales.activityLog(recordID),
          params: {
            fieldName: searchFieldName,
            downloadExcel: true
          }
        }}
        includeActiveColumns={false}
      />
  ];
};

export default ActivityTools;
